import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CEUMA_URL_VALIDA_DOCUMENTOS,LOGIN_CONTEXTO } from 'app/config';

@Injectable({
  providedIn: 'root'
})
export class ValidaService {

  constructor(private http: HttpClient) { }

  listarAlunos(): Observable<any>{
    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Contexto': LOGIN_CONTEXTO
      })
    }
    return this.http.get(CEUMA_URL_VALIDA_DOCUMENTOS+'/diploma/', httpOptions)
    .catch(this.errorHandler);
  }

  errorHandler(error: HttpErrorResponse){
    return Observable.throw(error.message || "Server error");
  }


}
